import React, { Component } from 'react'
import FicheProduit from './FicheProduit'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import ErrorPage from '../ErrorPage'

const query = gql`
  query FicheProduct($idProduct: ID!) {
    ficheProduct(idProduct: $idProduct) {
      id
      name
      description
      available
      saleMode {
        ... on PackedSale {
          id
          offers {
            id
            pieces
            quantity
            price
            unit
          }
        }

        ... on BulkSale {
          id
          price
          unit
        }
      }
      photosProduct {
        id
        cloudPath
        legende
        position
      }
      producerProfile {
        id
        companyName
        regionName
        departmentName
        regionCode
        departmentCode
        hasMail
        address {
          id
          postalCode
          city
        }
        valid
        categories {
          id
          reference
        }
        products {
          id
          name
          available
          saleMode {
            ... on PackedSale {
              id
              offers {
                id
                pieces
                quantity
                price
                unit
              }
            }
            ... on BulkSale {
              id
              price
              unit
            }
          }
          photosProduct {
            id
            cloudPath
            position
          }
        }
      }
    }
  }
`

class FicheProductContainer extends Component {
  render() {
    const {
      data: { ficheProduct, loading }
    } = this.props

    return !loading &&
      (!ficheProduct ||
        ficheProduct.producerProfile.valid !== 'ACCEPTE' ||
        !ficheProduct.available) ? (
      <ErrorPage />
    ) : (
      <FicheProduit product={ficheProduct} loading={loading} />
    )
  }
}

export default graphql(query, {
  options: ({
    match: {
      params: { idProduct }
    }
  }) => ({ variables: { idProduct } })
})(FicheProductContainer)
